import { ColorNeutralWhite, Spacing24, Spacing32, Spacing40, Spacing64 } from 'autogen/design-tokens/tokens';
import { pseudoStripes } from 'modules/helpers/style';
import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';

type colorStringType = string;
export interface IWithStripes extends HTMLAttributes<HTMLDivElement> {
    primaryColor: colorStringType;
    secondaryColor?: colorStringType;
}

const Wrapper = styled.div<IWithStripes>`
    position: relative;
    background-color: ${({ primaryColor }) => primaryColor};
    padding: ${Spacing24} 0 ${Spacing32};

    ${breakpoint.up(sizes.lg)} {
        padding: ${Spacing40} 0 ${Spacing64};
    }

    ${({ primaryColor, secondaryColor }) =>
        pseudoStripes({ color1: primaryColor, color2: secondaryColor, position: 'bottom', height: '12px' })};

    ${breakpoint.up(sizes.lg)} {
        ${({ primaryColor, secondaryColor }) =>
            pseudoStripes({ color1: primaryColor, color2: secondaryColor, position: 'bottom', height: '24px' })};
    }
`;

const Container = styled.div`
    width: 100%;
`;

export default function WithStripes({
    primaryColor,
    secondaryColor = ColorNeutralWhite,
    ...restProps
}: IWithStripes): JSX.Element {
    const { children } = restProps;

    return (
        <Wrapper primaryColor={primaryColor} secondaryColor={secondaryColor} {...restProps}>
            <Container className="container-fluid">{children && restProps.children}</Container>
        </Wrapper>
    );
}
